import "./common/styles/iconfont.css";
import "./common/styles/iconfont_website.css";
// import LanguageDetector from "i18next-browser-languagedetector";
import i18n from "i18next";
import enUsTrans from "./locales/en/index";
import zhCnTrans from "./locales/zh/index";
import jaTrans from "./locales/ja/index";
import { initReactI18next } from "react-i18next";
// document.cookie = "i18nextLng='zh'";
// const i18nextLng = document.cookie.i18nextLng || "en-US";

i18n
  // .use(LanguageDetector) // 监测当前浏览器语言
  .use(initReactI18next) // 初始化 i18n
  .init({
    resources: {
      "en-US": {
        translation: enUsTrans,
      },
      "zh-CN": {
        translation: zhCnTrans,
      },
      "ja-JP": {
        translation: jaTrans,
      },
    },
    fallbackLng: "zh-CN",
    // fallbackLng: i18nextLng, // 默认语言
    debug: false,
    preload: true,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });
function getCookie(name) {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

  if (typeof document !== "undefined") {
    arr = document.cookie.match(reg);
    if (arr) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  } else {
    return null;
  }
  // if (typeof document !== "undefined" && arr === document.cookie.match(reg)) return unescape(arr[2]);
  // else return null;
}

function getLang() {
  if (typeof document == "undefined") {
    return "zh-CN";
  }
  return (
    getCookie("_authing_lang") || navigator.language || navigator.userLanguage
  );
}
i18n.changeLanguage(getLang());

export default i18n;
